import Raven from 'raven-js';
export class GlobalSearchError extends Error {
  constructor(error) {
    super();
    this.message = `GlobalSearch_${error.message}`;
    this.stack = error.stack;
  }
}
export function trackError(error, errorName = '') {
  const noticeError = new GlobalSearchError(error);
  //TBD
  const extraErrorMetadata = {
    errorName
  };
  Raven.captureException(noticeError, {
    extra: extraErrorMetadata
  });
}
export default {
  trackError
};